/* eslint-disable react/prop-types */
// Copyright (c) 2019 Deere & Company

import EditableField from './editable-field';
import InputWithError from './input-with-error';
import LabeledFormInput from './labeled-form-input';
import PropTypes from 'prop-types';
import React from 'react';

export const getFieldClassName = (fieldClass, isValid, highlightClass) => {

    const fieldClassName = `${fieldClass} ${highlightClass}`;

    return isValid ?
        fieldClassName :
        `${fieldClassName} user-id-error`;

};

const LabeledInputWithBlur = ({
    className, highlightClass, isValid,
    label, isEditable, formatter, type = 'text',
    value, vsrMessage, handleBlur, handleChange, ...props
}) => {

    const modifiedClassName = getFieldClassName(className, isValid, highlightClass);

    return (
        <LabeledFormInput
            className={modifiedClassName}
            label={label}
        >
            <EditableField
                isEditable={isEditable}
                value={formatter ? formatter(value) : value}
            >
                <InputWithError
                    {...props}
                    isValid={isValid}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    addMultipleData={() => props.addMultipleData(label)}
                    type={type}
                    value={value}
                    vsrMessage={vsrMessage}
                />
            </EditableField>
        </LabeledFormInput>
    );

};

LabeledInputWithBlur.displayName = 'LabeledInputWithBlur';
LabeledInputWithBlur.propTypes = {
    className: PropTypes.string,
    formatter: PropTypes.func,
    isEditable: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    type: PropTypes.string,
    value: PropTypes.string.isRequired,
};

export default LabeledInputWithBlur;
